export default "__VITE_ASSET__2118dc70__"